// import { createContext, useState } from "react";

// export let CounterContext = createContext(0);  // createContext(0) اي قيمه مش فارقه

// function CounterContextProvide(props)
// {
//     const [counter, setCounter] = useState(0)

  

//     return <CounterContext.Provider value={{}}>
//                 {props.children}   
//     </CounterContext.Provider>
// }
// export default CounterContextProvide;


import { createContext, useEffect, useState } from "react";

export const ProductsContext = createContext();

export default function ProductsProvider({ children }) {
  const [allProducts, setAllProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);

  // جلب المنتجات من الـ API
  useEffect(() => {
    fetch('https://fakestoreapi.com/products')
      .then(res => res.json())
      .then(data => {
        setAllProducts(data);
        setFilteredProducts(data); // مبدئيًا نعرض الكل
      });
  }, []);

  // فلترة حسب التصنيف
  const filterByCategory = (category) => {
    if (category === 'all') {
      setFilteredProducts(allProducts);
    } else {
      const filtered = allProducts.filter(item => item.category === category);
      setFilteredProducts(filtered);
    }
  };

  return (
    <ProductsContext.Provider value={{ allProducts, filteredProducts, filterByCategory }}>
      {children}
    </ProductsContext.Provider>
  );
}
